module.exports = __webpack_public_path__ + "img/oufu_95x115x12.prt.39b3806b.jpg";